// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-projected {
  position: relative;
  width: calc(100% - 8px);
  max-width: 280px;
  height: auto;
  padding: 16px;
  margin-left: 8px;
  margin-bottom: 8px;
  color: inherit;
}
.card-projected .border {
  position: absolute;
  z-index: -1;
  top: 8px;
  left: -8px;
  width: 100%;
  height: 100%;
  border: 1px solid;
  display: block;
}
.card-projected-content {
  width: 100%;
  height: 100%;
}
.card-projected h2 {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 16px;
}
.card-projected p {
  font-size: 13px;
  line-height: 1.2;
}
@media screen and (min-width: 375px) {
  .card-projected {
    max-width: 319px;
  }
}
@media screen and (min-width: 1280px) {
  .card-projected {
    max-width: 381px;
  }
  .card-projected h2 {
    font-size: 20px;
    margin-bottom: 24px;
  }
  .card-projected p {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/cards/card-projected/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AACF;AACE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AACJ;AACE;EACE,WAAA;EACA,YAAA;AACJ;AAEE;EAEI,eAAA;EACA,gBAAA;EAEF,gBAAA;EACA,mBAAA;AAFJ;AAIE;EACE,eAAA;EACA,gBAAA;AAFJ;AAKE;EAtCF;IAuCI,gBAAA;EAFF;AACF;AAGE;EAzCF;IA0CI,gBAAA;EAAF;EAEE;IACE,eAAA;IACA,mBAAA;EAAJ;EAEE;IACE,eAAA;EAAJ;AACF","sourcesContent":[".card-projected {\n  position: relative;\n  width: calc(100% - 8px);\n  max-width: 280px;\n  height: auto;\n  padding: 16px;\n  margin-left: 8px;\n  margin-bottom: 8px;\n  color: inherit;\n\n  .border {\n    position: absolute;\n    z-index: -1;\n    top: 8px;\n    left: -8px;\n    width: 100%;\n    height: 100%;\n    border: 1px solid;\n    display: block;\n  }\n  &-content {\n    width: 100%;\n    height: 100%;\n  }\n\n  h2 {\n    font:{\n      size: 16px;\n      weight: 700;\n    }\n    line-height: 1.3;\n    margin-bottom: 16px;\n  }\n  p {\n    font-size: 13px;\n    line-height: 1.2;\n  }\n\n  @media screen and (min-width: 375px) {\n    max-width: 319px;\n  }\n  @media screen and (min-width: 1280px) {\n    max-width: 381px;\n\n    h2 {\n      font-size: 20px;\n      margin-bottom: 24px;\n    }\n    p {\n      font-size: 16px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
